import { useNavigate, Link } from "react-router-dom";
import { useCallback, useState } from "react";
import React from "react";
import "../Home/Home.css";
import "./Admin.css";
import { AdminHeader } from "../Header/AdminHeader";
import { AdminSidebar } from "../Sidebar/AdminSidebar";
import { hasPermission, permissionConfig } from "_helpers/permissions";
import { useCustomTable } from "_hooks/useCustomTable";
import { userListColumns } from "_components/mapper/userListColumns";
import { SearchOrder } from "_components/SearchOrder";
import FilterChips from "_components/FilterChips";
import { ExportFileButton } from "_components/ExportFileButton";
import CustomTable from "_components/CustomTable";
import { Filter } from "_components/Filter";
import { FilterModal } from "_components/filterModal";
import { exportUserList, getUserList } from "_services/userCreationApi";
import toastError from "_hooks/toast";

export { AdminUserList };

function AdminUserList() {
  const navigate = useNavigate();
  const adminAccess = hasPermission(permissionConfig.adminAccess);
  const [selectAllActive, setSelectAllActive] = useState(false);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const pageSize = 20;

  const fetchDataFn = async () => {
    return await getUserList({
      page,
      pageSize,
      sortField: sortBy[0]?.id || "",
      sortOrder: sortBy[0]?.desc ? "DESC" : "ASC",
      searchQuery: searchQuery ? searchQuery.trim() : "",
      filters,
    });
  };

  const {
    data,
    loading,
    totalCount,
    page,
    filters,
    setFilters,
    searchQuery,
    setSearchQuery,
    resetStoreData,
    fetchMoreData,
    fetchData,
    filterModalOpen,
    setFilterModalOpen,
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    state: { sortBy },
  } = useCustomTable({
    defaultColumns: userListColumns,
    fetchDataFn,
    setSelectAllActive,
    setSelectValue: setSelectedUserIds,
  });

  const gotoPage = (e, r) => {
    navigate(`/admin-user-list/${r.value}`)
  };

  const filtersObj = [{ label: "User ID", key: "userIds", type: "text" }];

  const applyFilters = (filter) => {
    let formmattedFilter = {};
    Object.keys(filter).map((filterKey) => {
      if (Array.isArray(filter[filterKey])) {
        formmattedFilter[filterKey] = filter[filterKey]
          .map((item) => item.trim())
          .filter((item) => item);
      } else {
        formmattedFilter[filterKey] = filter[filterKey];
      }
    });
    setFilterModalOpen(false);
    resetStoreData();
    setFilters(formmattedFilter);
  };

  const removeFilter = useCallback((filterKey, value, dateKey) => {
    setFilters((prevFilters) => {
      const newFilters = { ...prevFilters };
      const currentFilter = newFilters[filterKey];
      if (Array.isArray(currentFilter)) {
        newFilters[filterKey] = currentFilter.filter((item) => item !== value);
        if (newFilters[filterKey].length === 0) {
          delete newFilters[filterKey];
        }
      } else if (value instanceof Date && newFilters[filterKey]) {
        delete newFilters[filterKey];
      } else {
        delete newFilters[filterKey];
      }
      return newFilters;
    });
    resetStoreData();
  }, []);

  const [load, setLoad] = useState(false);
  const getDownload = async () => {
    setLoad(true);
    if (selectAllActive) {
      await exportUserList({
        sortField: sortBy[0]?.id || "",
        sortOrder: sortBy[0]?.desc ? "DESC" : "ASC",
        searchQuery: searchQuery ? searchQuery.trim() : "",
        filters,
      });
    } else if (selectedUserIds.length > 0) {
      await exportUserList({
        userIds: selectedUserIds,
      });
    } else {
      toastError("❗ Please select atleast one value");
    }
    setLoad(false);
  };

  return (
    <div className="admin-details-page-sec">
      <AdminSidebar />
      <div className="admin-details-page-body">
        <AdminHeader />
        <div className="admin-details-info">
          <div className="search-filter-part relative d-flex align-center justify-between">
            <SearchOrder
              filter={searchQuery}
              setFilter={setSearchQuery}
              resetData={resetStoreData}
            />
            <Filter click={() => setFilterModalOpen(true)} />
            <div className="approvals-cost-box relative">
              {adminAccess && (
                <button
                  type="button"
                  className="approvals-cost-btn relative d-flex align-center justify-center"
                  onClick={() => navigate("/admin-user-list/user-creation")}
                // onClick={openPopup}
                >
                  <img src="/images/done_all.svg" alt="approve cost" /> Create
                  User
                </button>
              )}
            </div>
            <ExportFileButton load={load} getDownload={getDownload} />
          </div>

          <FilterChips
            filters={filters}
            removeFilter={removeFilter}
            setFilterModalOpen={setFilterModalOpen}
          />
          <div className="all-listing-table table-sec">
            <CustomTable
              totalCount={totalCount}
              getTableProps={getTableProps}
              fetchMoreData={fetchMoreData}
              getTableBodyProps={getTableBodyProps}
              headerGroups={headerGroups}
              rows={rows}
              pageSize={pageSize}
              prepareRow={prepareRow}
              page={page}
              loading={loading}
              selectAllActive={selectAllActive}
              setSelectAllActive={setSelectAllActive}
              resetStoreData={resetStoreData}
              selectedInput={selectedUserIds}
              setSelectedInput={setSelectedUserIds}
              gotoPage={gotoPage}
              selectionColKey={"id"}
              selectionColName={adminAccess && "User Id"}
              loadMore={totalCount > (page + 1) * pageSize}
              checkBoxReq={true}
            />
          </div>

          {filterModalOpen && (
            <FilterModal
              onClose={() => setFilterModalOpen(false)}
              applyFilters={applyFilters}
              selectedFilters={filters}
              filtersObj={filtersObj}
            />
          )}
        </div>
      </div>
    </div>
  );
}
